import { Skeleton } from "@mui/material";
import React, { useEffect, useState } from "react";
import api from "../../api/api";
import { useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "../../../src/assets/orders/Save.svg";
import { useDispatch, useSelector } from "react-redux";
import { addIcon, heartIcon, starIcon } from "./svg";
import { setConfig } from "../../reduxtoolkit/userconfigslice";
import dayjs from "dayjs";
import { resolveOrderDate } from "../../utils/orderdate";
import { OrderIcons } from "../OrderCards";
import { getPracticeId } from "../../config/practice";

const LabsNavButtons = ({
  data,
  userdata,
  startDate,
  appointmentId,
  getordersData,
  selectedCard,
  dt,
  loading,
  selectedSuggestionList,
  fetchsuggestions,
}) => {
  const [selectedTabs, setSelectedTabs] = useState([]);
  const [selectedAddTabs, setSelectedAddTabs] = useState(false);
  const practiseid = getPracticeId();
  const dispatch=useDispatch()
  const params = useParams();
  

 const userConfig = useSelector((state) => state.userconfig);

  const tovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov")?.value
  );

  const lovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov")?.value
  );
let fav=userConfig?.config?.fav_labs||[]
  const inHouseLabsContent = [
    "CBC",
    "A1C",
    "CMP",
    "LIPIDS",
    "MAGNESIUM",
    "URIC ACID",
    "THYROID PANEL",
    "VIT D",
    "VIT B12",
    "TESTO",
  ];
  const stripfluContent = ["STREP TEST", "FLU TEST", "COVID TEST"];

  useEffect(() => {
    if (
      !Array.isArray(selectedSuggestionList) ||
      selectedSuggestionList.length === 0
    ) {
      setSelectedTabs([]); // Clear the selected tabs if the suggestion list is invalid or empty
      return;
    }

    const selectedItems= data
  .map((item) =>
    selectedSuggestionList.some(
      (suggestion) =>
        suggestion.ordername.toLowerCase() === item.content.toLowerCase()
    )
      ? item.content
      : null
  );


    setSelectedTabs(selectedItems);
  }, [data, selectedSuggestionList]);

  const handleTabClick = async (itemContent) => {
const isSelected = selectedTabs.some(
  (tab) => tab?.toLowerCase() === itemContent?.toLowerCase()
);

    const orderType = ["STREP TEST", "FLU TEST", "COVID TEST"].includes(
      itemContent
    )
      ? "Diagnostic test"
      : "labs";
    try {
      if (isSelected) {
        // Call delete API
        const orderToDelete = selectedSuggestionList.find(
        (x) => x.ordername?.toLowerCase() === itemContent?.toLowerCase()

        );

        if (orderToDelete) {
          const deleteResponse = await api.delete(
            `/v1/${practiseid}/orders/delete/order/${orderToDelete.ordre_id}`,
            {
              data: {
                // orderdate:  userdata.created_at?new Date(userdata.created_at).toISOString().split('T')[0]: "Invalid date",
                // the date this tab's list was loaded for (never today's fallback: the server
                // picks orders_master or its history table from it, and their ids collide)
                orderdate: resolveOrderDate(dt),
                // scopes the delete to this patient where the server supports it
                ...(userdata?.patientid ? { patientid: Number(userdata.patientid) } : {}),
              },
            }
          );
          console.log("Delete API Response:", deleteResponse?.message);
          
        } else {
          console.error("Order ID not found for deletion");
        }
      } else {
        const createResponse = await api.post(
          `/v1/${practiseid}/patient/${userdata.patientid}/orders/create`,
          {
            department_id: 1,
            patient_name: `${userdata.firstname || ""} ${
              userdata.lastname || ""
            }`.trim(),
            tov: tovValue, // purpose
            lov: userdata.lov,
            diagnosis: "",
            ordertype: orderType, // tabs
            ordername: itemContent, // buttons
            schedule: selectedCard, // t/f-schedule
            // provider: userdata.linked_provider,
            provider: `${userConfig?.firstname || ""} ${userConfig?.lastname || ""}`,
            status: "CREATED",
            confirm_status: "E", // C/E
            orderdate:
          dayjs(dt).isValid()
            ? dayjs(dt).format("YYYY-MM-DD")
            : dayjs().format("YYYY-MM-DD"),
            encounterid: 0,
          }
        );
      }

      // Update state after the API call
      setSelectedTabs((prevSelected) => {
        if (isSelected) {
          // Deselect if already selected
          return prevSelected.filter((content) => content !== itemContent);
        } else {
          // Select if not already selected
          return [...prevSelected, itemContent];
        }
      });
      fetchsuggestions();
    } catch (error) {
      console.error("Error in handleTabClick:", error);
    }
  };

  let isLoadingInHouseLabs = false; // This will track whether the function is already running

  // const handleInHouseLabsClick = async () => {
  //   if (isLoadingInHouseLabs) return; // Prevent double-clicking if already loading
  //   isLoadingInHouseLabs = true; // Set loading to true to prevent further invocations

  //   try {
  //     // Filter out the items that are already in selectedTabs
  //     const itemsToAdd = inHouseLabsContent.filter(
  //       (content) =>
  //         !selectedTabs.includes(content) &&
  //         !selectedSuggestionList.some((item) => item.ordername === content)
  //     );

  //     if (itemsToAdd.length > 0) {
  //       // Call handleTabClick for all items that are not in selectedTabs in parallel
  //       await Promise.all(itemsToAdd.map((content) => handleTabClick(content)));

  //       // Update selectedTabs with the newly added items
  //       selectedTabs.push(...itemsToAdd);
  //     }
  //   } catch (error) {
  //     console.error("Error in handleInHouseLabsClick:", error);
  //   } finally {
  //     isLoadingInHouseLabs = false; // Reset the loading state after the operation is complete
  //   }
  // };
const handleInHouseLabsClick = async () => {
  if (isLoadingInHouseLabs) return; // Prevent double-click
  isLoadingInHouseLabs = true;

  try {
    const updatedTabs = [...selectedTabs]; // Make a copy to update safely

    await Promise.all(
      inHouseLabsContent.map(async (content) => {


        // const isAlreadySelected = updatedTabs.includes(content);
  const isAlreadySelected = updatedTabs.some(
          (tab) => tab?.toLowerCase() === content?.toLowerCase()
        );
        // Call handleTabClick (handles UI / data logic)
        await handleTabClick(content);

        // Toggle add/remove in selectedTabs
        if (isAlreadySelected) {
          // Remove if already selected
          const index = updatedTabs.indexOf(content);
          if (index !== -1) updatedTabs.splice(index, 1);
        } else {
          // Add if not selected
          updatedTabs.push(content);
        }
      })
    );

    // Update state/variable after all are processed
    setSelectedTabs(updatedTabs)
    
    } catch (error) {
    console.error("Error in handleInHouseLabsClick:", error);
  } finally {
    isLoadingInHouseLabs = false; // Reset loading
  }
};


      let isLoading = false; // This will track whether the function is already running
  // const handleStrepFluCovidClick = async () => {


  //   if (isLoading) return; // Prevent double-clicking if already loading
  //   isLoading = true; // Set loading to true to prevent further invocations
  //   try {
  //     // First, filter out the items that are already in selectedTabs or selectedSuggestionList
  //     const itemssToAdd = stripfluContent.filter(
  //       (content) =>
  //         !selectedTabs.includes(content) &&
  //         !selectedSuggestionList.some((item) => item.ordername === content)
  //     );

  //     if (itemssToAdd.length > 0) {
  //       // Call handleTabClick for all items that are not in selectedTabs or selectedSuggestionList in parallel
  //       await Promise.all(
  //         itemssToAdd.map((content) => handleTabClick(content))
  //       );
  //       selectedTabs.push(...itemssToAdd);
  //     }
  //   } catch (error) {
  //     console.error("Error in handleStrepFluCovidClick:", error);
  //   } finally {
  //     isLoading = false; // Reset the loading state after the operation is complete
  //   }
  // };
const handleStrepFluCovidClick = async () => {
  if (isLoading) return; // Prevent double-click
  isLoading = true;

  try {
    const updatedTabs = [...selectedTabs]; // Copy safely

  
    await Promise.all(
      stripfluContent.map(async (content) => {


        // const isAlreadySelected = updatedTabs.includes(content);
  const isAlreadySelected = updatedTabs.some(
          (tab) => tab?.toLowerCase() === content?.toLowerCase()
        );
        // Call handleTabClick (handles UI / data logic)
        await handleTabClick(content);

        // Toggle add/remove in selectedTabs
        if (isAlreadySelected) {
          // Remove if already selected
          const index = updatedTabs.indexOf(content);
          if (index !== -1) updatedTabs.splice(index, 1);
        } else {
          // Add if not selected
          updatedTabs.push(content);
        }
      })
    );

    // Update state/variable after all are processed
    setSelectedTabs(updatedTabs)
  } catch (error) {
    console.error("Error in handleStrepFluCovidClick:", error);
  } finally {
    isLoading = false;
  }
};



const areAllInHouseLabsSelected = inHouseLabsContent.every((item) =>
  selectedTabs.some(
    (tab) => tab?.toLowerCase() === item?.toLowerCase()
  )
);

const updateFavLabs = async (lab) => {
  try {
    let updatedFavs = [...fav];
    if (!updatedFavs.includes(lab)) {
      updatedFavs.push(lab);
    }

   const response= await api.put(`/v1/${practiseid}/user/config`, {
      rowid: userConfig.id,
      fav_labs: updatedFavs,
    });
 if (response.status === 200) {
      // Update Redux state with the new config
      dispatch(setConfig({
        ...userConfig,
        config: {
          ...userConfig.config,
          fav_labs: updatedFavs,
        },
      }));
    }
    console.log("Fav labs updated:", updatedFavs);
  } catch (error) {
    console.error("Error updating fav labs:", error);
  }
};
const removeFavLab = async (lab) => {
  try {
    // Create a new array without the lab to remove
    const updatedFavs = fav.filter((l) => l !== lab);

    // Update the server
    const response = await api.put(`/v1/${practiseid}/user/config`, {
      rowid: userConfig.id,
      fav_labs: updatedFavs,
    });

    if (response.status === 200) {
      // Update Redux state
      dispatch(setConfig({
        ...userConfig,
        config: {
          ...userConfig.config,
          fav_labs: updatedFavs,
        },
      }));
    }

    console.log("Fav labs updated:", updatedFavs);
  } catch (error) {
    console.error("Error removing fav lab:", error);
  }
};
const handlelabclick = async (x) => {
  if (isLoading) return; // Prevent multiple clicks
  isLoading = true;

  try {
    const contentToAdd = x; // Assuming it's a string

    if (!selectedTabs.includes(contentToAdd) &&
        !selectedSuggestionList.some((item) => item.ordername === contentToAdd)) {
      await handleTabClick(contentToAdd);
      selectedTabs.push(contentToAdd);
    }
  } catch (error) {
    console.error("Error in handleStrepFluCovidClick:", error);
  } finally {
    isLoading = false;
  }
};

  const isOn = (content) =>
    selectedTabs.some((tab) => tab?.toLowerCase() === content?.toLowerCase());
  // The male / female in-house panels are order sets in the design. The data
  // spells them "Inhouse Labs-Male", so match without case.
  const isInhouseSingle = (content) => /^inhouse labs-(male|female)$/i.test(content || "");
  const inhouseSingle = data.filter((item) => isInhouseSingle(item.content));
  const strepFluCovidOn = stripfluContent.every((test) =>
    selectedSuggestionList.some((item) => item.ordername?.toLowerCase() === test?.toLowerCase())
  );
  const SetTag = () => <span className="bmor-set-tag">Labs</span>;

  return (
    <div className="bmor">
      {loading ? (
        <div className="bmor-skel" style={{ marginTop: 16 }}>
          {Array.from({ length: 6 }).map((_, index) => (
            <Skeleton key={index} variant="rectangular" width={120} height={42} style={{ borderRadius: 999 }} />
          ))}
        </div>
      ) : data.length > 0 ? (
        <>
          {/* Order sets sit under Favourites (no separate heading). */}
          <div className="bmor-section">
            <span className="bmor-section-title">
              <span style={{ width: 14, height: 14, color: "#e0a422", display: "inline-flex" }}>{OrderIcons.star}</span>
              Favourites
            </span>
            <span className="bmor-section-hint">Your saved labs</span>
          </div>
          <div className="bmor-chips">
            {inhouseSingle.map((item) => (
              <button
                key={item.content}
                type="button"
                className={`bmor-set cat-labs${isOn(item.content) ? " on" : ""}`}
                onClick={() => handleTabClick(item.content)}
              >
                {OrderIcons.labs}
                {/female/i.test(item.content) ? "In-house labs — female" : "In-house labs — male"}
                <SetTag />
              </button>
            ))}
            <button
              type="button"
              className={`bmor-set cat-labs${areAllInHouseLabsSelected ? " on" : ""}`}
              onClick={handleInHouseLabsClick}
            >
              {OrderIcons.labs}
              In-house labs
              <SetTag />
            </button>
            <button
              type="button"
              className={`bmor-set cat-labs${strepFluCovidOn ? " on" : ""}`}
              onClick={handleStrepFluCovidClick}
            >
              {OrderIcons.labs}
              Strep / Flu / COVID
              <SetTag />
            </button>
          </div>

          <div className="bmor-chips">
            {fav.map((lab) => (
              <button
                key={lab}
                type="button"
                className={`bmor-chip${isOn(lab) ? " on" : ""}`}
                onClick={() => handlelabclick(lab)}
              >
                {isOn(lab) ? OrderIcons.check : OrderIcons.plus}
                {lab}
                <span
                  className="bmor-chip-x"
                  role="button"
                  title="Remove from favourites"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent parent click
                    removeFavLab(lab);
                  }}
                >
                  ×
                </span>
              </button>
            ))}
            <button
              type="button"
              className="bmor-chip ghost"
              aria-expanded={!!selectedAddTabs}
              onClick={() => setSelectedAddTabs((prev) => !prev)}
            >
              {selectedAddTabs ? "Done" : <>{OrderIcons.plus}Add favourite</>}
            </button>
          </div>
          {!!selectedAddTabs && (
            <div className="bmor-chips" style={{ marginTop: 10 }}>
              {data
                .filter(
                  (x) => !isInhouseSingle(x.content) && !fav.includes(x.content)
                )
                .map((item) => (
                  <button
                    key={item.content}
                    type="button"
                    className="bmor-chip"
                    onClick={() => updateFavLabs(item.content)}
                  >
                    <span style={{ color: "#d0533f", display: "inline-flex" }}>{OrderIcons.heart}</span>
                    {item.content}
                  </button>
                ))}
            </div>
          )}

          <div className="bmor-section">
            <span className="bmor-section-title">
              <span className="bmor-section-dot" />
              Labs
            </span>
            <span className="bmor-section-hint">Select to add, select again to remove</span>
          </div>
          <div className="bmor-chips">
            {data
              .filter((x) => !isInhouseSingle(x.content))
              .map((item) => {
                const isSelected = selectedTabs.includes(item.content);
                const displayText = stripfluContent.includes(item.content)
                  ? item.content.charAt(0).toUpperCase() + item.content.slice(1).toLowerCase()
                  : item.content;
                return (
                  <button
                    key={item.content}
                    type="button"
                    className={`bmor-chip${isSelected ? " on" : ""}`}
                    aria-pressed={isSelected}
                    onClick={() => handleTabClick(item.content)}
                  >
                    {isSelected ? OrderIcons.check : OrderIcons.plus}
                    {displayText}
                  </button>
                );
              })}
          </div>
        </>
      ) : (
        <p className="bmor-empty-line" style={{ marginTop: 16 }}>No suggestions found</p>
      )}
    </div>
  );
};

export default LabsNavButtons;
